
import type { SVGProps } from 'react';
const SvgArticles = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14z" />
    <path fill="currentColor" d="M7 7h10v2H7zm0 4h10v2H7zm0 4h7v2H7z" />
  </svg>
);
export default SvgArticles;
